var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "aging-inventory-page-wrapper" },
    [
      !_vm.hasFailedRequests
        ? _c(
            "layout-secondary",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showMobileModal,
                  expression: "!showMobileModal"
                }
              ],
              attrs: {
                "page-model": _vm.pageModel,
                "title-text": _vm.$t("agingInventory.list.title"),
                "back-route": "/available-inventories"
              }
            },
            [
              _c(
                "div",
                { staticClass: "filters-container" },
                [
                  _c("flex-row", [
                    _c(
                      "div",
                      { staticClass: "col col--no-grow" },
                      [
                        _c("select-filter", {
                          attrs: {
                            id: "aging-inventory-filter-type",
                            name: "filters.filterTypes",
                            column: _vm.filters.filterTypes,
                            searchable: false,
                            "option-label": "label",
                            "value-field": "value",
                            "track-by": "value"
                          },
                          on: { filter: _vm.filter },
                          scopedSlots: _vm._u([
                            {
                              key: "singleLabel",
                              fn: function(ref) {
                                var option = ref.option
                                return [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(option.label) +
                                      "\n                        "
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col col--no-grow" },
                      [
                        _c("select-filter", {
                          attrs: {
                            id: "aging-inventory-date-range",
                            name: "filters.dateRange",
                            column: _vm.filters.dateRange,
                            searchable: false,
                            "option-label": "label",
                            "value-field": "value",
                            "track-by": "value"
                          },
                          on: { filter: _vm.filter },
                          scopedSlots: _vm._u([
                            {
                              key: "singleLabel",
                              fn: function(ref) {
                                var option = ref.option
                                return [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(option.label) +
                                      "\n                        "
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col col--no-grow export-button" },
                      [
                        _c("export-button", {
                          attrs: {
                            url: _vm.exportUrl,
                            text: _vm.$t(
                              "agingInventory.labels.downloadGridData"
                            )
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm.messageWarning
                    ? _c("flex-row", [
                        _c("div", { staticClass: "col col--no-grow" }, [
                          _c("p", { staticClass: "messageWarning" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.messageWarning()) +
                                "\n                    "
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm.$mq !== "mobile" || !_vm.pageModel.hasMobileView
                ? _c(
                    "base-table",
                    {
                      attrs: {
                        "fixed-header": "",
                        "invert-colors": "",
                        "offset-sides": "lg",
                        "row-uniq-id": _vm.pageModel.uniqueField,
                        columns: _vm.pageModel.columns,
                        rows: _vm.pageModel.table.items,
                        actions: _vm.pageModel.actions,
                        loading: _vm.pageModel.table.loading
                      }
                    },
                    [
                      _c("p", { attrs: { slot: "noData" }, slot: "noData" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("agingInventory.list.noResults")) +
                            "\n            "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.hasPages && _vm.$mq !== "mobile"
                ? _c("base-pagination", {
                    staticClass: "list-page__footer",
                    attrs: {
                      slot: "pagination",
                      "current-page": _vm.pageModel.table.page,
                      results: _vm.pageModel.table.total,
                      "items-per-page": _vm.pageModel.table.pageSize,
                      "page-route": _vm.currentPageRoute
                    },
                    on: { paging: _vm.paging },
                    slot: "pagination"
                  })
                : _vm._e()
            ],
            1
          )
        : _c(
            "layout-secondary",
            [_c("failed-to-load", { on: { retry: _vm.reloadComponent } })],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }